
import PrivacyPolicy from '../components/privacypolicy';
import { Helmet } from 'react-helmet';
import Navigation from '../components/navigation'
import Footer from '../components/footer'
const PrivacyPolicyPage = (props) => {
  return (
    <div className='container'>
            <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta property="og:title" content="Cysigil Network Pvt Ltd" />
        <link
          rel="canonical"
          href="https://www.cysigil.com"
        />
      </Helmet>
      <Navigation />
        <PrivacyPolicy />
        <Footer />
    </div>
      
  );
};

export default PrivacyPolicyPage;
